<template>
  <div class="revistaentry">
    {{$t('reuniao.reuniaode')}} {{ formattedDate }}
  </div>
</template>

<script>
import { i18n } from '@/main';
export default {
  props: ["item"],
  computed: {
    formattedDate() {
      if (!this.item?.data) return "";
      const date = new Date(this.item.data);
      const locale = i18n.global.locale === 'en' ? 'en-GB' : i18n.global.locale;
      const formatter = new Intl.DateTimeFormat(locale, { day: "2-digit", month: "long" });
      let formatted = formatter.format(date);
      // Capitalize the first letter of the month
      return formatted.replace(/de (\w+)/, (match, month) => {
        return `de ${month.charAt(0).toUpperCase()}${month.slice(1)}`;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.revistaentry, .revistaentry:hover{
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #707475;
  font-family: "Montserrat Semibold";
  font-size: 15px;
  cursor: pointer;

}
</style>